import { observer } from 'mobx-react-lite'
import { useRef, useState } from 'react'

import { useStore } from 'store/useStore'
import CustomSpin from 'components/ui/ThreeDotLoader/ThreeDotLoader'
import { TextArea } from 'components/uiKit'

import { MAX_MESSAGE_LENGTH } from '../../../data'
import { DialogBranches } from '../../../types'

import SendMessageIcon from 'assets/img/searchEngine/sendMessageIcon.svg?react'
import s from './ChatModalFooter.module.scss'

type InputModeType = 'numeric' | 'text'

export const ChatFooter = observer(() => {
  const [isButtonActive, setIsButtonActive] = useState(false)
  const { searchEngineUiStore: uiStore } = useStore()
  const buttonRef = useRef<HTMLButtonElement>(null)
  const disableSendBtn = uiStore.message === '' || uiStore.sending
  const inputMode: InputModeType = uiStore.dialogBranch.value === DialogBranches.regularChat ? 'text' : 'numeric'

  const handleFocus = () => {
    setIsButtonActive(true)
  }

  const handleSend = (e: React.KeyboardEvent<HTMLTextAreaElement> | React.MouseEvent) => {
    e.preventDefault()
    if (disableSendBtn) {
      return
    }
    uiStore.sendMessage()
    setIsButtonActive(false)
  }

  const handleSetMessage = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
    const enteredValue = event.target.value
    if (inputMode === 'numeric') {
      const numericMatch = enteredValue.match(/\d+/g)
      const numericValue = numericMatch ? numericMatch.join('') : ''
      uiStore.setMessage(numericValue)
    } else {
      uiStore.setMessage(enteredValue)
    }
  }

  return (
    <div className={s.footer}>
      <div className={s.footerSpinner}>{uiStore.sending && <CustomSpin spinning={true} />}</div>
      <TextArea
        className={s.textArea}
        onFocus={handleFocus}
        placeholder="Какой у вас вопрос?"
        style={{ resize: 'none' }}
        onChange={handleSetMessage}
        onPressEnter={(e) => handleSend(e)}
        value={uiStore.message}
        disabled={uiStore.sending}
        autoFocus
        maxLength={MAX_MESSAGE_LENGTH}
        autoSize={{ minRows: 1, maxRows: 4 }}
      />
      <button
        ref={buttonRef}
        disabled={disableSendBtn}
        onClick={(e) => handleSend(e)}
        className={`${s.sendMessageButton} ${isButtonActive ? s.active : ''}`}
      >
        <SendMessageIcon className={s.sendMessageIcon} width="24" height="24" fill="currentColor" />
      </button>
    </div>
  )
})
